import { render, staticRenderFns } from "./LuloPro.vue?vue&type=template&id=40a59960"
import script from "./LuloPro.vue?vue&type=script&lang=js"
export * from "./LuloPro.vue?vue&type=script&lang=js"
import style0 from "./LuloPro.vue?vue&type=style&index=0&id=40a59960&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports